import { useMutation, useQueryClient } from "@tanstack/react-query";
import { forceDeleteAllEmployees as apiFn } from "../../api/apiEmployees";
import { useSnackbar } from "notistack";
import getErrorMessageFromAxiosError from "../../utils/parseError";

export function useForceDeleteAllEmployees() {
    const qc = useQueryClient(); const { enqueueSnackbar } = useSnackbar();
    const { mutate: forceDeleteAllEmployees, isPending: isForceDelete } = useMutation({
        mutationFn: (req) => apiFn(req),
        onSuccess: (r) => { enqueueSnackbar(r.message, { variant: "success" }); qc.invalidateQueries({ queryKey: ["employees"] }); },
        onError: (err) => { enqueueSnackbar(getErrorMessageFromAxiosError(err), { variant: "error" }); },
    });
    return { forceDeleteAllEmployees, isForceDelete };
}
